/**
 * Форматирует номер банковской карты, добавляя пробелы и маскируя часть цифр
 * @param cardNumber - строка с номером карты (например: "4276180000000000")
 * @returns отформатированный номер карты (например: "4276 **** 0000 0000")
 */
export const maskCardNumber = (cardNumber: string): string => {
	const cleanNumber = cardNumber.replace(/\D/g, '');

	if (cleanNumber.length !== 16) {
		throw new Error('Номер карты должен содержать 16 цифр');
	}

	const firstFour = cleanNumber.slice(0, 4);
	const lastEight = cleanNumber.slice(8, 16);

	const lastFour = lastEight.slice(4, 8);
	const secondLastFour = lastEight.slice(0, 4);

	return `${firstFour} **** ${secondLastFour} ${lastFour}`;
};

export const formatCardNumber = (cardNumber: string): string => {
	const cleanNumber = cardNumber.replace(/\D/g, '');

	return cleanNumber.replace(/(.{4})/g, '$1 ').trim();
};
